import { createElement, type HTMLAttributes } from 'react';
import { cn } from '@skupreme/shared/ui';

const CATALOG_INVENTORY_TABS = {
  INVENTORY_FLOW: 'Inventory Flow',
  SALES_FORECAST: 'Sales Forecast',
  VIEW_FORMULA: 'View Formula',
};

export const TIMELINE_TABS = {
  ...CATALOG_INVENTORY_TABS,
  VIEW_FORMULA: 'View Formula',
};

export const KEYS_TIMELINE_TABS = Object.keys(TIMELINE_TABS);
export const KEYS_CATALOG_TIMELINE_TABS = Object.keys(CATALOG_INVENTORY_TABS);

/* Callers mark the parts of a stat with `label` / `value` class names. */
const TAB_INFORMATION = cn(
  'sk:flex sk:items-center sk:gap-4 sk:text-[15px] sk:font-normal sk:leading-normal',
  'sk:max-[1150px]:flex-col sk:max-[1150px]:items-end sk:max-[1150px]:gap-y-2.5 sk:max-[1150px]:text-right',
  'sk:[&_.label]:text-fg-secondary sk:[&_.value]:pl-0.5 sk:[&_.value]:text-fg',
);

export function TabInformation({
  className,
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return createElement('div', {
    ...rest,
    className: cn(TAB_INFORMATION, className),
  });
}

export function TabContent({
  className,
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return createElement('div', { ...rest, className: cn('sk:mt-5', className) });
}
